module.exports = __webpack_public_path__ + "img/aleksandr.05056f27.png";